export type GlobalLoaderProps = unknown

export type GlobalLoaderComponent = React.FC<GlobalLoaderProps>

interface GlobalLoadersProps {
  loaders: GlobalLoaderComponent[]
}

export const GlobalLoaders: React.FC<GlobalLoadersProps> = ({ loaders }) =>
  loaders.map((LoaderComponent, index) => <LoaderComponent key={index} />)
